import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { useAuthStore } from "@/lib/auth-store";
import { PERMISOS } from "@/lib/permisos";
import { useSolicitud } from "@/features/solicitudes/hooks/use-solicitud";
import { useSolicitudPolling } from "@/features/solicitudes/hooks/use-solicitud-polling";
import {
  calcularIntervaloPolling,
  estaEnEsperaDeAutorizacion,
} from "@/features/solicitud-detalle/utils/estado-flags";
import { Route } from "@/routes/_authed-tw/solicitudes/$id/index";
import { DetalleHeader } from "./DetalleHeader";
import { DetalleLayout } from "./DetalleLayout";

export function SolicitudDetallePage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: sol } = useSolicitud(id);
  useSolicitudPolling(id, calcularIntervaloPolling(sol));

  // Solo redirigimos a la vista ENFOCADA de autorización a quien ACTÚA sobre el
  // flujo (autoriza) o sobre la solicitud (la gestiona/captura). Un viewer de
  // solo lectura (Visor/Auditor) se queda en el detalle con pestañas, donde el
  // resumen le muestra datos generales, proveedor, CFDI, prorrateo y documentos.
  const puedeActuar = useAuthStore((s) => {
    const p = s.user?.permisos ?? [];
    return (
      p.includes(PERMISOS.autorizacionAutorizar) ||
      p.includes(PERMISOS.solicitudesGestionar) ||
      p.includes(PERMISOS.contrapagosGestionar)
    );
  });
  const enEspera = estaEnEsperaDeAutorizacion(sol.estado) && puedeActuar;
  useEffect(() => {
    if (enEspera) {
      void navigate({
        to: "/solicitudes/$id/autorizacion",
        params: { id },
        replace: true,
      });
    }
  }, [enEspera, id, navigate]);

  if (enEspera) return null;

  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <DetalleHeader sol={sol} />
      <DetalleLayout sol={sol} />
    </div>
  );
}
